import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocalizationService } from './core/services/localization/localization.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('smm-landing-page');
  protected readonly localization = inject(LocalizationService);
}
